/*
 * Created on Fri Nov 24 2017
 *
 * Copyright (c) 2017 Sébastien Hecart
 */

import { I00DEBGAZ_State } from '@batical/types/src'

import { debitNormaux, debitGazReel, debitTopGaz36s } from '../CommonFormula'

function I00DEBGAZ_docalcul(state: I00DEBGAZ_State) {
  const res_debitNormaux = debitNormaux(state.in_puissanceNominale, state.in_pci)
  const res_debitGazReel = debitGazReel(state.in_pressionAtmospherique, state.in_pressionGaz, state.in_temperatureGaz, res_debitNormaux)
  return {
    ...state,
    res_debitNormaux,
    res_debitGazReel,
    res_debitTopGaz36: debitTopGaz36s(res_debitGazReel),
    invalidated: false
  }
}

export default I00DEBGAZ_docalcul
